"use client";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaArrowRight } from "react-icons/fa";
import Image from "next/image";
import { CLIENT_API_ROUTES } from "@/utils/clientApiRoutes";
import { useEffect, useState } from "react";
import axios from "axios";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
};

function Header() {
  const [banners, setBanners] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(CLIENT_API_ROUTES?.GET_BANNERS);

      setBanners(response?.data?.banners || []);
    } catch (err) {
      console.error("Error Fetching banners:", err?.message);
      setBanners([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="h-[450px] md:h-[600px] w-full">
    
      {banners?.length > 0 && (
        <div>
          <Carousel
            swipeable={true}
            draggable={true}
            showDots={true}
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            arrows={false}
            autoPlaySpeed={3500}
            keyBoardControl={true}
            customTransition="transform 800ms ease-in-out"
            // customTransition="all .5"
            transitionDuration={0}
            containerClass="w-full h-full"
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            pauseOnHover={false}
          >
            {banners.map((item, i) => (
              <div key={i} className="h-[450px] md:h-[600px] w-full relative">
                <div className="absolute h-full w-full z-10 inset-0 bg-[#084c7c5b]"></div>

                <div
                  className="h-full w-[90%] md:w-[85%] mx-auto flex 
                justify-center sm:justify-start items-center relative inset-0 z-20"
                >
                  <div
                    className="h-[350px] w-[350px] md:h-[420px] md:w-[500px] rounded-sm 
                  flex flex-col justify-center items-start gap-3 md:gap-6 p-4 md:p-12 backdrop-blur-xs bg-[#ffffff85]"
                  >
                    <p className="text-[#053c63] animate-slideUp font-bold text-xl md:text-3xl">
                      {item?.title}
                    </p>
                    <div className="space-y-2">
                      <p className="text-sm md:text-sm line-clamp-9 text-gray-700 font-medium">
                        {item?.description}
                      </p>
                      <a href={item?.link || null}
                      target="_blank"
                      >
                        <p className="text-[#053c63] font-bold">
                          Learn More <FaArrowRight className="inline text-sm" />{" "}
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                {item?.image && (
                  <Image
                    src={item?.image}
                    alt={`Banner ${i}`}
                    fill
                    className="object-cover"
                    priority
                  />
                )}
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
}

export default Header;
